import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FeedbackReducer, MainLangType } from 'types/mainPage';

const initialState: FeedbackReducer = {
  name: '',
  mail: '',
  message: '',
  confirm: false,
  isOpenModal: false,
  isOpenInfoModal: false,
  openWarningModal: false,
  infoLang: 'ru',
  feedbackText: '',
};

export const feedbackSlice = createSlice({
  initialState,
  name: 'feedback',
  reducers: {
    setName(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    setMail(state, action: PayloadAction<string>) {
      state.mail = action.payload;
    },
    setMessage(state, action: PayloadAction<string>) {
      state.message = action.payload;
    },
    setConfirm(state, action: PayloadAction<boolean>) {
      state.confirm = action.payload;
    },
    setOpenModal(state, action: PayloadAction<boolean>) {
      state.isOpenModal = action.payload;
    },
    setOpenInfo(state, action: PayloadAction<boolean>) {
      state.isOpenInfoModal = action.payload;
    },
    setOpenWarningModal(state, action: PayloadAction<boolean>) {
      state.openWarningModal = action.payload;
    },
    setLang(state, action: PayloadAction<MainLangType>) {
      state.infoLang = action.payload;
    },
    setFeedbackText(state, action: PayloadAction<string>) {
      state.feedbackText = action.payload;
    },
    resetFeedback() {
      return initialState;
    },
  },
});

export default feedbackSlice.reducer;
